<template>
  <div
    class="d-flex-column justify-start level_adjusters stadium_rank b-radius-9 gap-0"
  >
    <h6 class="regular-xxxl f-w-700 font-family-2 t-white">{{ title }}</h6>
    <p class="t-grey font-family-2 regular-m">{{ description }}</p>

    <div class="d-flex-row" style="margin-top: 18px">
      <div
        class="stadium_rank_picker gap-10 b-radius-6"
        :class="[isOpen && 'opened']"
        @click.stop="toggleOpen"
        v-click-outside="closeOpen"
      >
        <p class="t-grey font-family-2 regular-l" v-if="!selectedRank">
          {{ description }}
        </p>
        <div
          class="d-flex-row justify-start flex gap-2 width-max-content"
          v-else-if="selectedRank"
        >
          <img
            :src="selectedRank.icon"
            alt=""
            class="rank_image"
            height="40"
            width="40"
          />

          <p class="t-white font-family-2 regular-l">
            {{ selectedRank.title }}
          </p>
        </div>
        <ChevDown />

        <Transition name="slide-fade-top">
          <div class="rank_selector_drop b-radius-6" v-if="isOpen">
            <div
              class="t-white item"
              :class="[
                checkoutStore.getDetails[`${type}Slab`] === rank.slab &&
                  'active_item',
              ]"
              v-for="rank in computedRanks"
              @click.stop="selectRank(rank)"
            >
              <img :src="rank.icon" alt="" class="rank_image" />
              <span class="t-white font-family-2 regular-l">{{
                rank.title
              }}</span>
            </div>
          </div>
        </Transition>
      </div>

      <!-- <ValueSetter :min="min" :max="max" v-model="value" :step="step" /> -->
    </div>
  </div>
</template>

<script setup>
import ChevDown from "~/components/icons/ChevDown.vue";
const isOpen = ref(false);
const checkoutStore = useCheckoutStore();
const props = defineProps({
  title: {
    default: "",
  },
  description: {
    default: "",
  },
  ranks: {
    default: [],
  },
  type: {
    default: "",
  },
  selectedRank: {
    default: null,
  },
  prevRank: {
    default: null,
  },
});
const closeOpen = () => {
  if (isOpen.value) {
    isOpen.value = false;
  }
};

const toggleOpen = () => {
  isOpen.value = !isOpen.value;
};

const selectRank = (rank) => {
  const key = `${props.type}Title`;
  const key2 = `${props.type}Slab`;
  if (
    props.type === "currentRank" &&
    rank.slab >= checkoutStore.getDetails.desiredRankSlab
  ) {
    const nextRank = computedRanks.value.find((rnk) => rnk.slab > rank.slab);
    checkoutStore.setDetails({
      ...checkoutStore.getDetails,
      desiredRankSlab: nextRank.slab,
      desiredRankTitle: rank.title,
    });
  }
  closeOpen();

  checkoutStore.setDetails({
    ...checkoutStore.getDetails,
    [key]: rank.title,
    [key2]: rank.slab,
  });
};

const selectedRank = computed(() => {
  const key2 = `${props.type}Slab`;

  if (checkoutStore.getDetails[key2]) {
    return props.ranks?.find(
      (rank) => rank.slab === checkoutStore.getDetails[key2]
    );
  }
  return null;
});

const computedRanks = computed(() => {
  if (props.prevRank) {
    return props.ranks?.filter((rank) => rank.slab !== props.prevRank);
  }
  if (props.type === "currentRank") {
    return [...props.ranks].slice(0, -1);
  }
  return props.ranks;
});
</script>

<style lang="scss">
.stadium_rank {
  .stadium_rank_picker {
    position: relative;
    display: flex;
    height: 40px;
    width: 100%;
    padding: 0px 12px;
    justify-content: center;
    align-items: center;
    gap: 20px;
    flex-shrink: 0;
    align-self: stretch;
    border: 1px solid var(--stroke-dark);
    background-color: var(--bg-medium);
    position: relative;
    svg {
      transition: all 0.2s ease;
    }
    &.opened {
      svg {
        transform: rotate(180deg);
      }
    }
  }
  .rank_selector_drop {
    .rank_image {
      width: 40px;
      height: 40px;
      object-fit: contain;
      object-position: center;
    }
    position: absolute;
    top: 105%;
    left: 0%;
    width: 100%;
    height: max-content;
    max-height: 30vh;
    overflow: auto;
    background-color: var(--bg-medium);
    border: 1px solid var(--stroke-medium);

    z-index: 9999;
    border-radius: 3px;
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
    padding: 6px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    z-index: 10;
    gap: 6px;
    .item {
      width: 100%;
      outline: none;
      height: 48px;
      border: none;
      text-align: start;
      // padding: 11px;
      border-radius: 3px;
      -moz-border-radius: 3px;
      -webkit-border-radius: 3px;
      cursor: pointer;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 5px;
      z-index: 1;
      @media screen and (max-width: 480px) {
        padding: 16px;
      }

      &.active_item {
        background-color: var(--bg-main);
        color: var(--white);
      }
    }
  }
}
</style>
